const paymentStatusTransformer = data => {
  // TODO:
  let filteredValues = data?.filter(item => ["pending", "completed", "rejected", "in_progress"].includes(item?.key))
  filteredValues?.push({ id: null, key: null, name: "All", value: null })
  let finalValue = filteredValues?.map(item => ({ ...item, value: item?.id?.toString() }))

  return finalValue
}

export default paymentStatusTransformer
